import { request } from '../../Common/api/client';

/**
 * GET /api/admin/cp - 가맹점 목록
 * @param {object} params - q(검색어), status, page, limit 등
 */
export async function getAdminCpList(params = {}) {
  return request({ method: 'GET', url: '/api/admin/cp', params });
}

/**
 * POST /api/admin/cp - 가맹점 신규 생성
 * @param {object} body - {
 *   cpId, name, bossName, businessNo, phone, tempPassword, feeRate (required),
 *   address (사업장 주소, optional),
 *   bankName/bank_name, accountNumber/bank_account_number, accountHolder/bank_account_holder (optional)
 * }
 * @returns {Promise<{cp_id, cpId, tempPassword}>}
 */
export async function createAdminCp(body) {
  const {
    bankName, bank_name,
    bankCode, bank_code,
    accountNumber, bankAccountNumber,
    accountHolder, bankAccountHolder,
    ...rest
  } = body;
  const data = {
    ...rest,
    address: body.address ?? rest.address ?? '',
    bankName: bank_name ?? bankName ?? '',
    bankCode: bank_code ?? bankCode ?? '',
    bankAccountNumber: body.bank_account_number ?? bankAccountNumber ?? accountNumber ?? '',
    bankAccountHolder: body.bank_account_holder ?? bankAccountHolder ?? accountHolder ?? '',
  };
  return request({ method: 'POST', url: '/api/admin/cp', data });
}

/**
 * GET /api/admin/cp/detail - 가맹점 상세정보
 * @param {number|string} id - 가맹점 ID (cp.id)
 */
export async function getAdminCpDetail(id) {
  return request({
    method: 'GET',
    url: '/api/admin/cp/detail',
    params: { id },
  });
}

/**
 * POST /api/admin/cp/update - 가맹점 상세정보 수정
 * @param {object} body - 수정할 필드 (id 필수), address, feeRate (수수료율), bankName/bankCode/accountNumber/accountHolder 등
 */
export async function updateAdminCp(body) {
  const {
    bankName, bank_name,
    bankCode, bank_code,
    accountNumber, bankAccountNumber,
    accountHolder, bankAccountHolder,
    feeRate, fee_rate,
    ...rest
  } = body;
  const data = {
    ...rest,
    address: body.address ?? rest.address ?? '',
    feeRate: fee_rate ?? feeRate ?? rest.feeRate ?? '',
    bankName: bank_name ?? bankName ?? '',
    bankCode: bank_code ?? bankCode ?? '',
    bankAccountNumber: body.bank_account_number ?? bankAccountNumber ?? accountNumber ?? '',
    bankAccountHolder: body.bank_account_holder ?? bankAccountHolder ?? accountHolder ?? '',
  };
  return request({
    method: 'POST',
    url: '/api/admin/cp/update',
    data,
  });
}

/**
 * POST /api/admin/cp/reset-password - 가맹점 비밀번호 변경
 * @param {object} body - { cpId, password }
 */
export async function resetAdminCpPassword(body) {
  return request({
    method: 'POST',
    url: '/api/admin/cp/reset-password',
    data: body,
  });
}
